module.exports = __webpack_public_path__ + "static/img/eco-protection-01.3e3f4c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/eco-protection/eco-protection-01.jpg
// module id = R8Mu
// module chunks = 96